module.exports = __webpack_public_path__ + "static/media/gastro-main-3.7c34c9aa.jpg";